import LancarNotasPage from "@/Pages/Notas/LancarNotasPage.vue";

export default [
  {
    path: "/gestoes-de-aulas/:gestaoDeAulasId/notas/lancar",
    name: "notas.lancarNotas",
    component: LancarNotasPage,
  },
];
